<template>
  <div class="info">
    <h2 style="margin-bottom: 30px">Faucet Addresses</h2>
    <table id="customers" style="margin-bottom: 30px">
      <thead>
        <tr>
          <th colspan="1">Public Chains</th>
          <th colspan="1">Testnet Names</th>
          <th colspan="1">URL</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>TRON</td>
          <td>Nile</td>
          <td>
            <el-link
              href="https://nileex.io/join/getJoinPage"
              :underline="false"
              target="_blank"
              type="primary"
              >Nile Faucet</el-link
            >
          </td>
        </tr>
        <tr>
          <td>ETH</td>
          <td>Sepolia</td>
          <td>
            <el-link
              href="https://sepolia-faucet.pk910.de/"
              :underline="false"
              target="_blank"
              type="primary"
              >Sepolia Faucet</el-link
            >
          </td>
        </tr>
        <tr>
          <td>BSC</td>
          <td>BSC Testnet</td>
          <td>
            <el-link
              href="https://testnet.binance.org/faucet-smart"
              :underline="false"
              target="_blank"
              type="primary"
              >BSC Faucet</el-link
            >
          </td>
        </tr>
      </tbody>
    </table>
    <span
      >*TRX/ETH/BNB acquired on TRON/ETH/BSC testnet faucets can also be
      transferred to BitTorrent Chain Donau through
    </span>
    <el-link
      href="https://test-app.bt.io/bridge"
      :underline="false"
      target="_blank"
      type="primary"
    >
      BitTorrent Bridge</el-link
    >
    <span
      >. Please go to the corresponding faucets to get testnet tokens.
    </span>
    <br /><br /><br />
    <el-divider></el-divider>
    <br />
    <div>
      <h2>BitTorrent Chain Donau Network Configuration</h2>
      <span
        >You need to use MetaMask in order to access BitTorrent Chain Donau and add
        it to your network.</span
      >
      <ul style="padding-left: 20px; margin-top: 20px">
        <li style="margin-bottom: 5px">Network Name:</li>
        <span style="font-weight: bold">BitTorrent Chain Donau</span>
        <li style="margin-top: 10px; margin-bottom: 5px">RPC URL:</li>
        <span style="font-weight: bold"
          >https://pre-rpc.bt.io/</span
        >
        <li style="margin-top: 10px; margin-bottom: 5px">ChainID:</li>
        <span style="font-weight: bold">1029</span>
        <li style="margin-top: 10px; margin-bottom: 5px">Symbol:</li>
        <span style="font-weight: bold">BTT</span>
        <li style="margin-top: 10px; margin-bottom: 5px">
          Block Explorer URL:
        </li>
        <span style="font-weight: bold">https://testscan.bt.io</span>
      </ul>
    </div>
    <div
      style="cursor: pointer; margin-top: -15px; margin-right: 20px"
      @click="addRpc"
    >
      <img
        src="metamask.svg"
        style="float: right; margin-top: 20px"
        onMouseOver="this.style.cursor='hand';"
      />
    </div>
  </div>
</template>

<script>
// import detectEthereumProvider from "@metamask/detect-provider";

export default {
  data() {
    return {};
  },
  methods: {
    async addRpc() {
      try{
        window.ethereumMM
        .request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainId: "0x405",
              chainName: "BitTorrent Chain Donau",
              nativeCurrency: {
                name: "BitTorrent",
                symbol: "BTT",
                decimals: 18,
              },
              rpcUrls: ["https://pre-rpc.bt.io"],
              blockExplorerUrls: ["https://testnet.bttcscan.com"],
            },
          ],
        })
        .catch((error) => {
          console.log(error);
        });
      }catch(e){
        console.log(e)
      }
    },
  },
};
</script>

<style>
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  width: 100%;
  border-collapse: collapse;
}
#customers td,
#customers th {
  font-size: 1em;
  border: 1px solid #000000;
  padding: 10px;
  text-align: center;
}
#customers th {
  font-size: 1.1em;
  padding-top: 5px;
  padding-bottom: 4px;
  background-color: #ffffff;
  color: #000000;
}
#customers tr.alt td {
  color: #000000;
  background-color: #eaf2d3;
}
</style>
